import type { FC } from "react";
import RadioInput from "../radio-input/radio-input";
import type { RadioInputConfig } from "../radio-input/radio-input.types";

type RadioGroupProps = {
	items: RadioInputConfig[];
	onChange: (id: string) => void;
	activeId: string | null;
	vertical?: boolean;
};

const RadioGroup: FC<RadioGroupProps> = ({
	activeId,
	items,
	onChange,
	vertical,
}) => {
	return (
		<div
			style={{
				display: "flex",
				gap: vertical ? "1rem" : "2rem",
				flexDirection: vertical ? "column" : "row",
			}}
		>
			{items.map(({ id, label, disabled }) => (
				<RadioInput
					key={id}
					label={label}
					checked={activeId === id}
					disabled={disabled}
					id={id}
					onCheck={() => onChange(id)}
				/>
			))}
		</div>
	);
};

export default RadioGroup;
